<template>
  <v-row justify="space-between" v-if="!cookieConsent">
    <v-col md="6" cols="12" class="text-center text-md-start">
      <div class="font-weight-bold ">🍪 שימוש בקוקיס</div>
      <div class="text-body-1 text-black mb-2">
        האתר משתמש בקוקיס לשיפור חוויית הגלישה ומתן שירותים מותאמים.
      </div>
      <div>
        <a :href="policyUrl" target="_blank" rel="noopener" class="custom-link">
          📋 מדיניות פרטיות
        </a>
      </div>
    </v-col>
    <v-col md="3" cols="12" class="d-flex justify-end align-center">
      <v-btn variant="text" class="do-not-show-again-btn" @click="doNotShowAgain">
        אל תראה לי את זה עוד
        פעם
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      policyUrl: 'https://docs.google.com/document/d/17SDpR4hRujA8tSEBH-xDlbc9G3R-0Wdim6ds_Dzf4Y0/edit?tab=t.0'
    }
  },
  methods: {
    doNotShowAgain() {
      localStorage.setItem('cookieConsent', 1);
      console.log('Cookies do not show again');
      this.$emit('consent');
    }
  }
}
</script>
<style lang="scss">
.do-not-show-again-btn {
  background: linear-gradient(135deg, #A8E6CF 0%, #88D8A3 100%);
  color: #98ba9b;
  border: 2px solid #A8E6CF;
}

.do-not-show-again-btn:hover {
  background: linear-gradient(135deg, #88D8A3 0%, #A8E6CF 100%);
  color: #2C5530;
  border: 2px solid #88D8A3;
}
</style>
